import { get, type Readable, type Unsubscriber } from "svelte/store"

// This utility type extracts the type T from each Readable<T> in the tuple
type UnpackReadableTuple<T> = {
    [K in keyof T]: T[K] extends Readable<infer U> ? U : never
}

// The multisub function with improved type inference
export function multisub<T extends Readable<unknown>[], U extends UnpackReadableTuple<T>>(
    readables: [...T],
    callback: (...args: U) => void,
): Unsubscriber {
    // Implement the logic to call the callback with the values from the readables
    // Assuming each Readable<T> has a 'subscribe' method that takes a callback
    const values: unknown[] = readables.map((v) => get(v))
    const unsubscribers: Unsubscriber[] = []
    readables.forEach((readable, index) => {
        unsubscribers.push(
            readable.subscribe((value) => {
                // let changed = false
                // for (let indexCheck = 0; indexCheck < values.length; indexCheck++) {
                //     if (indexCheck === index) {
                // This wouldn't be called if it wasn't different
                // so no need to check
                values[index] = value
                // } else {
                //     const checkVal = values[indexCheck]
                //     const newVal = get(readables[indexCheck])
                //     if (checkVal !== newVal) {
                //         values[indexCheck] = newVal
                //         changed = true
                //     }
                // }
                // }
                if (values.length === readables.length) {
                    callback(...(values as U))
                }
            }),
        )
    })

    return () => {
        unsubscribers.forEach((subscribe) => subscribe())
    }
}
